// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__yuKZu","deleteButtonWrapper":"styles_deleteButtonWrapper__ENp4V"};